import appLogo from '../../assets/images/app_logo.png';
import songsoptok from '../../assets/images/banner/songsoptok.svg';
import banner1 from '../../assets/images/banner1.jpg';
import banner2 from '../../assets/images/banner2.jpg';
import banner3 from '../../assets/images/banner3.jpg';
import banner4 from '../../assets/images/banner4.jpg';
import ebsco from '../../assets/images/digital Library/ebsco.png';
import emerald from '../../assets/images/digital Library/emerald.png';
import jstor from '../../assets/images/digital Library/jstor.png';
import projectMuse from '../../assets/images/digital Library/project muse.png';
import springer from '../../assets/images/digital Library/springer.png';
import iThenticate from "../../assets/images/iThenticate.jpeg";
import profileDemo from '../../assets/images/profile_demo.jpg';
import bookYourSlot from '../../assets/images/quick links/book your slot.png';
import citizensCharter from '../../assets/images/quick links/citizen charter_1.png';
import idCard from '../../assets/images/quick links/ID card.png';
import remote from '../../assets/images/quick links/Remote Access.png';
import thesis2 from '../../assets/images/quick links/thesis submission.png';
import institutional_repository from '../../assets/images/repository.jpg';

// Officer images
import MdAbdurRahaman from '../../assets/images/officers/abdur.jpg';
import MohammadAshrafulIslam from '../../assets/images/officers/ashraful.jpg';
import MdBodiulAlam from '../../assets/images/officers/bodiul.jpg';
import MdFarukHossain from '../../assets/images/officers/faruk.jpg';
import MdHabibeKibriaChawdhury from '../../assets/images/officers/habibe.jpg';
import MdMoklesurRahman from '../../assets/images/officers/mokhlesur.jpg';
import AbuSayedMdMostafizurRahaman from '../../assets/images/officers/mostafizur.jpg';
import NazmaBegum from '../../assets/images/officers/nazma.jpg';
import ParveenAktar from '../../assets/images/officers/parveen.jpg';
import JesminParvin from '../../assets/images/officers/parvin.jpg';
import MdRezaulHaque from '../../assets/images/officers/rezaul.jpg';
import MdRiazMahmud from '../../assets/images/officers/riaz.jpg';
import MSalahuddinBhuiya from '../../assets/images/officers/salahuddin.jpg';
import ShimulKumarBarua from '../../assets/images/officers/shimul kumar.jpg';

// Staff images
import MdAbdulBased from '../../assets/images/staffs/abdul based.jpg';
import MdAbdulMotaleb from '../../assets/images/staffs/abdul.jpg';
import MdAliHossain from '../../assets/images/staffs/ali.jpg';
import MdAmirulIslam from '../../assets/images/staffs/amirul.jpg';
import MdBadiujjaman from '../../assets/images/staffs/badiujjaman.jpg';
import BibiSaharaBanu from '../../assets/images/staffs/bib.jpg';
import BiplobKumarSarkar from '../../assets/images/staffs/biplop.jpg';
import DelowaraKhatun from '../../assets/images/staffs/delowara.jpg';
import MdGaziurRahaman from '../../assets/images/staffs/gazi.jpg';
import SreeGonesh from '../../assets/images/staffs/gonesh.jpg';
import JahanaraAkhter from '../../assets/images/staffs/jahanara.jpg';
import MdKamalHossain from '../../assets/images/staffs/kamal.jpg';
import DKartik from '../../assets/images/staffs/kartik.jpg';
import MahbuburRahman from '../../assets/images/staffs/mahbubur.jpg';
import MaidulIslamMamun from '../../assets/images/staffs/maidul.jpg';
import MdMasudRana from '../../assets/images/staffs/masud.jpg';
import MdMizanurRahaman from '../../assets/images/staffs/mizanur.jpg';
import MofizulIslamSaddam from '../../assets/images/staffs/mofizul.jpg';
import MdNurulIslam from '../../assets/images/staffs/nurul.jpg';
import PalashChandraSarkar from '../../assets/images/staffs/pollash.png';
import ProsantaRajbongshi from '../../assets/images/staffs/prosanto.jpg';
import MahadyHasanRaja from '../../assets/images/staffs/raja.jpg';
import RezowanaRahman from '../../assets/images/staffs/rezowana.jpg';
import RubinaAkther from '../../assets/images/staffs/rubina.jpg';
import MdSaidurRahman from '../../assets/images/staffs/saidur.jpg';
import TaouhidMollah from '../../assets/images/staffs/taouhid.jpg';
import SreeTrinad from '../../assets/images/staffs/trinad.jpg';
import OpenAthens from '../../assets/images/Openathence.png';

const IMAGES = {
    banner1,
    banner2,
    banner3,
    banner4,
    ebsco,
    emerald,
    jstor,
    springer,
    citizensCharter,
    idCard,
    remote,
    thesis2,
    profileDemo,
    bookYourSlot,
    songsoptok,
    projectMuse,
    appLogo,
    iThenticate,
    institutional_repository,
    OpenAthens,
    // Officer images
    AbuSayedMdMostafizurRahaman,
    MSalahuddinBhuiya,
    MohammadAshrafulIslam,
    MdRezaulHaque,
    MdHabibeKibriaChawdhury,
    NazmaBegum,
    MdAbdurRahaman,
    JesminParvin,
    MdBodiulAlam,
    MdMoklesurRahman,
    ShimulKumarBarua,
    MdFarukHossain,
    ParveenAktar,
    MdRiazMahmud,
    // Staff images
    MdSaidurRahman,
    MdBadiujjaman,
    BiplobKumarSarkar,
    MdMasudRana,
    DelowaraKhatun,
    MdAbdulMotaleb,
    SreeGonesh,
    RezowanaRahman,
    MdAbdulBased,
    JahanaraAkhter,
    MdAmirulIslam,
    MdNurulIslam,
    MdGaziurRahaman,
    MdKamalHossain,
    SreeTrinad,
    MdAliHossain,
    ProsantaRajbongshi,
    PalashChandraSarkar,
    BibiSaharaBanu,
    MdMizanurRahaman,
    RubinaAkther,
    MaidulIslamMamun,
    MofizulIslamSaddam,
    TaouhidMollah,
    MahbuburRahman,
    MahadyHasanRaja,
    DKartik
};

export default IMAGES;
